
// Get all movements
export const getMovementsStart =()=>({
    type: "GET_MOVEMENTS_START",
});
export const getMovementsSuccess =(movements)=>({
    type: "GET_MOVEMENTS_SUCCESS",
    payload: movements,
});
export const getMovementsFailure =(error)=>({
    type: "GET_MOVEMENTS_FAILURE",
    payload: error,
});


// Add one movement
export const addMovementStart =()=>({
    type: "ADD_MOVEMENT_START",
});
export const addMovementSuccess =(movement)=>({
    type: "ADD_MOVEMENT_SUCCESS",
    payload: movement,
});
export const addMovementFailure =(error)=>({
    type: "ADD_MOVEMENT_FAILURE",
    payload: error,
});

// Load Décharge
export const loadDechargeStart =()=>({
    type: "LOAD_DECHARGE_START",
});
export const loadDechargeSuccess =(detail)=>({
    type: "LOAD_DECHARGE_SUCCESS",
    payload: detail,
});
export const loadDechargeFailure =(error)=>({
    type: "LOAD_DECHARGE_FAILURE",
    payload: error,
});

// Submit Client/Entreprise Décharge
export const submitDechargeStart =()=>({
    type: "SUBMIT_DECHARGE_START",
});
export const submitDechargeSuccess =(response)=>({
    type: "SUBMIT_DECHARGE_SUCCESS",
    payload: response,
});
export const submitDechargeFailure =(error)=>({
    type: "SUBMIT_DECHARGE_FAILURE",
    payload: error,
});

// Submit Retour/Autre Décharge
export const submitRetourAutreDechargeStart =()=>({
    type: "SUBMIT_RETOUR_AUTRE_DECHARGE_START",
});
export const submitRetourAutreDechargeSuccess =(response)=>({
    type: "SUBMIT_RETOUR_AUTRE_DECHARGE_SUCCESS",
    payload: response,
});
export const submitRetourAutreDechargeFailure =(error)=>({
    type: "SUBMIT_RETOUR_AUTRE_DECHARGE_FAILURE",
    payload: error,
});

// Get Client/Entreprise Décharge
export const getMovementDechargeStart =()=>({
    type: "GET_MOVEMENT_DECHARGE_START",
});
export const getMovementDechargeSuccess =(response)=>({
    type: "GET_MOVEMENT_DECHARGE_SUCCESS",
    payload: response,
});
export const getMovementDechargeFailure =(error)=>({
    type: "GET_MOVEMENT_DECHARGE_FAILURE",
    payload: error,
});

// Get Retour/Autre Décharge
export const getMovementRetourAutreDechargeStart =()=>({
    type: "GET_RETOUR_AUTRE_DECHARGE_START",
});
export const getMovementRetourAutreDechargeSuccess =(response)=>({
    type: "GET_RETOUR_AUTRE_DECHARGE_SUCCESS",
    payload: response,
});
export const getMovementRetourAutreDechargeFailure =(error)=>({
    type: "GET_RETOUR_AUTRE_DECHARGE_FAILURE",
    payload: error,
});

// Get one movement Encaissement
export const getMovementEncaissementStart =()=>({
    type: "GET_MOVEMENT_ENCAISSEMENT_START",
});
export const getMovementEncaissementSuccess =(response)=>({
    type: "GET_MOVEMENT_ENCAISSEMENT_SUCCESS",
    payload: response,
});
export const getMovementEncaissementFailure =(error)=>({
    type: "GET_MOVEMENT_ENCAISSEMENT_FAILURE",
    payload: error,
});

// Update movement dechargement
export const updateMovementDechargeStart =()=>({
    type: "UPDATE_MOVEMENT_DECHARGE_START",
});
export const updateMovementDechargeSuccess =(response)=>({
    type: "UPDATE_MOVEMENT_DECHARGE_SUCCESS",
    payload: response,
});
export const updateMovementDechargeFailure =(error)=>({
    type: "UPDATE_MOVEMENT_DECHARGE_FAILURE",
    payload: error,
});